<template>
  <div>
    <top-section title="Новини" :breadcrumb="breadcrumb" />
    <section class="blog_area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 mb-5 mb-lg-0">
            <div class="blog_left_sidebar" v-if="news.length">
              <post v-for="(post, i) in searchedNews" :key="i" :post="post" />
            </div>
            <h4 v-else>
              На жаль ми не змогли знайти новини по вашому запиту. Спробуйте
              ввести інше ключове слово.
            </h4>
          </div>
          <div class="col-lg-4">
            <div class="blog_right_sidebar">
              <search
                :is-filtered="isFiltered"
                @search="searchPost"
                @clear="clearSearch"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Post from "../components/News/Post.vue";
import Search from "../components/News/Search.vue";
import TopSection from "../components/TopSection.vue";

export default {
  components: { Search, Post, TopSection },
  name: "News",
  data: () => ({
    breadcrumb: [
      {
        title: "Головна",
        url: "/"
      },
      {
        title: "Новини",
        url: "/news"
      }
    ],
    isFiltered: false,
    searchedNews: []
  }),

  async created() {
    await this.$store.dispatch("FETCH_NEWS");
    this.searchedNews = this.news;
  },

  computed: {
    news() {
      return this.$store.getters.news;
    }
  },

  methods: {
    searchPost(str) {
      if (str.length) {
        this.isFiltered = true;
        this.searchedNews = this.news.filter(p =>
          p.title.toLowerCase().includes(str.toLowerCase())
        );
      } else {
        this.clearSearch();
      }
    },

    clearSearch() {
      this.isFiltered = false;
      this.searchedNews = this.news;
    }
  }
};
</script>
